module.exports = __webpack_public_path__ + "static/media/img_male.052ac092.svg";